module.exports = __webpack_public_path__ + "img/round.46050b1a.svg";